import React, { ReactNode, useState } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { Card } from "..";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";

const activeClassName = "nav-item-active";

const StyledLink = styled(NavLink).attrs({ activeClassName })`
  text-decoration: none;
  display: block;
  cursor: pointer;
  position: relative;
  padding: 8px 0;
  padding-left: 32px;
  border-bottom: 1px solid #a7a7a7;
  &:last-child {
    border-bottom: none;
  }
  &:hover .MuiTypography-colorTextPrimary {
    color: #e3232a;
  }
  &:hover::after {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #e3232a;
    top: 47%;
    left: 12px;
    transform: translate(0, -50%);
  }
  &.${activeClassName} {
    & .MuiTypography-colorTextPrimary {
      color: #e3232a;
    }
    &::after {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      background-color: #e3232a;
      top: 47%;
      left: 12px;
      transform: translate(0, -50%);
    }
  }
`;

type DataProps = {
  title: string;
  subUrl: string;
  component: ReactNode;
};

export type CardSubMenuProps = {
  title: string;
  url: string;
  data: DataProps;
};

const useStyles = makeStyles({
  listLink: {
    padding: "8px 0",
    paddingLeft: 0,
    cursor: "pointer",
  },
});

const CardSubMenu = ({ title, url, data, isId }: any) => {
  const [expandState, setExpandState] = useState(true);
  const classes = useStyles();
  return (
    <Card title={title}>
      {data.map(({ title, titleEn, subUrl, children }: any) => {
        if (children) {
          return (
            <div key={title} className={classes.listLink}>
              <div
                onClick={() => setExpandState(!expandState)}
                style={{ display: "flex", alignItems: "center", gap: 8 }}
              >
                {expandState ? <ExpandMore /> : <ExpandLess />}
                <Typography variant="h6" color="textPrimary">
                  {isId ? title : titleEn}
                </Typography>
              </div>
              {!expandState && (
                <div style={{ marginLeft: 16 }}>
                  {children.map((row: any) => (
                    <StyledLink key={row.title} to={url + row.subUrl}>
                      <Typography variant="h6" color="textPrimary">
                        {isId ? row.title : row.titleEn}
                      </Typography>
                    </StyledLink>
                  ))}
                </div>
              )}
            </div>
          );
        }
        return (
          <StyledLink key={title} to={url + subUrl}>
            <Typography variant="h6" color="textPrimary">
              {isId ? title : titleEn}
            </Typography>
          </StyledLink>
        );
      })}
    </Card>
  );
};

export default CardSubMenu;
